// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TG_v","textarea":"styles_textarea__pAGcP"};